import LandingScreenAnim from "./LandingScreenAnim";
export default LandingScreenAnim;